<template>
  <div>
    <!-- <div class="holdertit">
      Top 1,000 holders (From a total of {{ holdersList.length }} holders)
    </div> -->
    <div class="holdertit" v-if="holdersList.length >= 1000">
      Top {{ holderCount }} holders (From a total of {{ holderCount }} holders)
    </div>
    <div class="holdertit" v-if="holdersList.length <1000">
      A total of {{ holderCount }} holders
    </div>
    <div>
      <div class="Block_list">
        <ul class="block_list_Top">
          <li>Rank</li>
          <li>Adderss</li>
          <li>Quantity</li>
          <li>Percentage</li>
        </ul>
      </div>
      <div class="Block_List_center notranslate" v-show="holdersList.length > 0">
        <ul>
          <li v-for="(item, index) in holdersList" :key="index">
            <p>{{ index + 1 }}</p>
            <p @click="Addersstaken(item.ownerAddress)">
              {{ item.ownerAddress }}
            </p>
            <p>
             <span v-if="item.quantity>999"> {{ Number(item.quantity).toLocaleString() }}</span>
             <span v-else> {{ item.quantity }}</span>
            </p>
            <p>{{ item.sum }}%</p>
          </li>
        </ul>
      </div>
      <div :class="holdersList.length>10?'Block_List_Bottom':''" v-show="holdersList.length > 0">
        <el-pagination
          ref="Pagination"
          :current-page.sync="PaginationIndex"
          background
          :page-size="20"
          layout="prev, pager,
      next"
          @current-change="CurrentChange"
          :total="total1"
        >
        </el-pagination>
      </div>
      <div v-show="holdersList.length <= 0">
          <EmptyState />
        </div>
    </div>
  </div>
</template>

<script>
// import Pagination from "../BlockList/Pagination";
// import Pagination2 from "../BlockList/Pagination2.vue";
import EmptyState from "../EmptyState/EmptyState.vue";

export default {
  props: ["holdersList","holderCount","PaginationIndex"],
  data() {
    return {
    //  PaginationIndex: 1,
      total1: 1,
      nowLang: "",
      TimeDate: [],
      Page1: "",
     
    };
  },
  components: {
    // Pagination,
    EmptyState,
    // Pagination2,
  },
  // watch: {
  //   deep: true,
  //   holderCount(val) {
  //    console.log(val);
  //    this.total1=val;
  //   },
  //   // PaginationIndex(val){
  //   //   this.PaginationIndex=val;
  //   // }
    
  // },
  mounted() {
   // this.PaginationIndex = 1;
   // this.blockList();
  },
  computed: {
    // getClientTimezone() {
    //   var oDate = new Date();
    //   var nTimezone = -oDate.getTimezoneOffset() / 60;
    //   return nTimezone.toFixed(2);
    // },
  },
  methods: {
    CurrentChange(val) {
      this.PaginationIndex = val;
        
    this.$emit('getDatepage',val);
    //  this.blockList();
    },
 
    Block(index) {
      this.$router.push({
        path: "/pc/BkHeight",
        query: { height: index },
      });
    },
    Hash(index) {
      this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });
    },
    Addersstaken(index) {
    //  console.log(index);
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: index },
      });
   
      // let params = {
      //   contractAddress: index
      // };
      // this.$router.push({ path: "/pc/Overview", query: params });
    },

  },
};
</script>

<style lang="less" scoped>
.holdertit {
  font-size: 14px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #898b8d;
  line-height: 20px;
}
.Block_list {
  padding-top: 20px;
  .block_list_Top {
    display: flex;
    width: 1120px;
    height: 60px;
    background: #14151a;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    padding: 0 20px;
    li {
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
      line-height: 62px;
      -webkit-background-clip: text;
    }
    li:nth-child(1) {
      flex: 0 0 15%;
    }
    li:nth-child(2) {
      flex: 0 0 45%;
    }
    li:nth-child(3) {
      flex: 0 0 30%;
    }
    li:nth-child(4) {
      flex: 0 0 10%;
    }
  }
}
.Block_List_center {
  ul {
    height: 620px;
    padding: 0 20px;
    li:last-child{
        border-bottom: none;
      }
    li {
      display: flex;
      height: 62px;
      border-bottom: 1px solid #22252e;
      line-height: 62px;
      p {
        font-size: 14px;
        font-family: SF Pro Text-Regular, SF Pro Text;
        font-weight: 400;
        -webkit-background-clip: text;
      }
    }
    li:nth-child(10) {
     // border: none;
    }
    p:nth-child(1) {
      flex: 0 0 15%;
      font-size: 12px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
      font-size: 12px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      img {
        width: 34px;
        height: 34px;
        background: #22252e;
        border-radius: 172px 172px 172px 172px;
        opacity: 1;
        margin-top: 10px;
        margin-right: 5px;
      }
      span {
        display: inline-block;
        width: 280px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
    }
    p:nth-child(2) {
      flex: 0 0 45%;
      font-size: 12px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #fff;
      width: 100px;
      overflow: hidden;
      padding-right: 80px;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      position: relative;
      cursor: pointer;
      .Hover1 {
        display: none;
        .Hover {
          padding: 3px 10px;
          display: inline-block;
          line-height: 20px;
          position: absolute;
          top: -10px;
          left: 0px;
          background-color: #3c485c;
          border-radius: 5px;
          i {
            position: absolute;
            top: 18px;
            left: 40%;
            transform: rotate(180deg);
            color: #3c485c;
          }
        }
      }
    }
    p:nth-child(2):hover {
      .Hover1 {
        display: block !important;
      }
    }
    p:nth-child(3) {
      flex: 0 0 30%;
      font-size: 12px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
      span {
        display: inline-block;
        width: 280px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
    }
    p:nth-child(4) {
      flex: 0 0 10%;
      font-size: 12px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #898b8d;
    }
  }
}
.Block_List_Bottom {
  margin-top: 606px;
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color:#fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252E !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
